import { StoreDoc } from '@gooduncles/gu-app-schema';
import { ICellRendererParams } from 'ag-grid-community';
import { useEffect } from 'react';

import useSWRStore from 'src/hooks/swr/useSWRStore';

interface AgCellStoreProps extends ICellRendererParams {
  storeId: string;
  field: keyof StoreDoc;
}

/**
 * 매장 정보를 조회 및 표시하는 CellRenderer 컴포넌트
 */
const AgCellStore = (params: AgCellStoreProps) => {
  const storeId = params.storeId;
  const { store } = useSWRStore(storeId);
  const value = (store?.[params.field] ?? '') as string;

  useEffect(() => {
    if (params.setValue) {
      params.setValue(value);
    }
  }, [params, value]);

  return <span>{value}</span>;
};

export default AgCellStore;
